<template>
  <div role="status">
    <svg class="animate-[rotate_2s_linear_infinite]" viewBox="25 25 50 50">
      <circle class="spinner-circle-path" cx="50" cy="50" r="20" />
    </svg>
    <span class="sr-only">Laden...</span>
  </div>
</template>

<style scoped>
.spinner-circle-path {
  fill: none;
  stroke: currentColor;
  stroke-width: 3px;
  animation: animate-stroke 1.5s ease-in-out infinite;
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes animate-stroke {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
</style>
